import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import {
  agGridOptionsNone,
  agGridTheme,
  HOST_URL,
} from "../../helpers/constants/Constants.js";

import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import {
  addObject,
  addObjectProp,
  getObjectGroupings,
  getOPMGridData,
} from "../../helpers/axios/objectsAxios.js";
import Form from "react-bootstrap/Form";
import CreateMultiSelectComp from "../ag-grid/createMultiSelect.js";
import Modal from "react-bootstrap/Modal";

const ObjectLibrary = () => {
  // const [categories, setCategories] = useState(null);
  // const [category, setCategory] = useState(null);
  const [objectGroupings, setObjectGroupings] = useState([]);
  const [selectedGroupingId, setSelectedGroupingId] = useState(null);
  const [showAddObjectModal, setShowAddObjectModal] = useState(false);
  const [newObject, setNewObject] = useState({
    category: null,
    objectGroupingId: selectedGroupingId,
  });

  const [showAddObjectPropModal, setShowAddPropModal] = useState(false);
  const [newProp, setNewProp] = useState({
    property: null,
    objectGroupingId: selectedGroupingId,
  });

  const [propertiesFlag, setPropertiesFlag] = useState(false);

  const [gridData, setGridData] = useState(null);

  const addCustomComponents = useCallback(async (tempGridData) => {
    //Map Properties to columns
    var tempCols = [];
    var tempPropCols = [];

    tempGridData.columns.forEach((p) => {
      if (p.custom == false) {
        tempCols.push(p);
        return;
      }
      tempCols.push({
        ...p,
        onCellValueChanged: (params) => {
          var opm = fetchOPM(tempGridData.params.opmData, params.data.id, p.id);

          axios
            .put(HOST_URL + `/objects/propertiesMatrix`, {
              opm: opm,
            })
            .then((response) => {
              opm.id = response.data.id;
            })
            .catch(console.log);
        },
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: {
          values: [
            "3D",
            "P&ID",
            "Static",
            "Static - Hyperlink",
            "Dynamic",
            "Dynamic - Number",
            "Dynamic - Dropdown",
            "Dynamic - Fluid",
            "None",
          ],
        },
        valueGetter: (params) => {
          return (
            fetchOPM(tempGridData.params.opmData, params.data?.id, p.id)
              ?.objectProperty.origin ?? "None"
          );
        },
        valueSetter: (params) => {
          const opm = fetchOPM(
            tempGridData.params.opmData,
            params.data?.id,
            p.id,
          );
          let origin = null;
          let type = null;
          if (params.newValue.includes("-")) {
            origin = params.newValue.split("-")[0].trim();
            type = params.newValue.split("-")[1].trim();
          } else {
            origin = params.newValue;
          }
          if (opm) {
            opm.objectProperty.origin = origin;
            opm.objectProperty.type = type;
          } else {
            //Push temporary value with needed values
            tempGridData.params.opmData.push({
              id: null,
              objectId: params.data?.id,
              propertyId: p.id,
              objectProperty: {
                origin: origin,
                type: type,
              },
            });
          }
          return true;
        },
        cellRenderer: cellRenderer,
        cellRendererParams(params) {
          return {
            dataSource: fetchOPM(
              tempGridData.params.opmData,
              params.data?.id,
              p.id,
            ),
          };
        },
      });
    });
    tempGridData.columns = tempCols;

    tempGridData.dynamicPropColumns.forEach((p) => {
      if (p.custom === false) {
        tempPropCols.push(p);
        return;
      }
      tempPropCols.push({
        ...p,
        cellEditor: CreateMultiSelectComp,
        cellEditorPopup: true,
        editable: true,
        singleClickEdit: true,
        onCellValueChanged: (params) => {
          var opm = fetchOPM(tempGridData.params.opmData, params.data.id, p.id);
          opm.objectProperty.options = params.newValue.join(",");
          p.data.options = params.newValue.join(",");
          axios
            .put(HOST_URL + `/objects/propertiesMatrix`, {
              opm: opm,
            })
            .then((response) => {})
            .catch(console.log);
        },
        valueGetter: (params) => {
          var opmOptions = fetchOPM(
            tempGridData.params.opmData,
            params.data?.id,
            p.id,
          )?.objectProperty.options;
          return opmOptions?.split(",");
        },
        valueSetter: (params) => {
          var opm = fetchOPM(
            tempGridData.params.opmData,
            params.data?.id,
            p.id,
          );
          if (opm) {
            opm.objectProperty.options = params.newValue.join(",");
          }
          return true;
        },
        cellRenderer: cellRendererDynamicProperties,
        cellRendererParams(params) {
          return {
            dataSource: fetchOPM(
              tempGridData.params.opmData,
              params.data?.id,
              p.id,
            )?.objectProperty.options,
          };
        },
      });
    });
    tempGridData.dynamicPropColumns = tempPropCols;
  }, []);

  const loadOPMGridData = useCallback(async () => {
    let tempGridData = await getOPMGridData(selectedGroupingId);
    await addCustomComponents(tempGridData);
    setGridData(tempGridData);
  }, [addCustomComponents, selectedGroupingId]);

  useEffect(() => {
    (async () => {
      //Load groups and set the first to be selected
      let tempObjectGroupings = await getObjectGroupings();
      setObjectGroupings(tempObjectGroupings);
      setSelectedGroupingId(tempObjectGroupings[0].id);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (selectedGroupingId != null) {
        await loadOPMGridData();
      }
    })();
  }, [loadOPMGridData, propertiesFlag, selectedGroupingId]);

  const fetchOPM = (opm, objectId, propertyId) => {
    return opm.find(
      (opm) => opm.objectId == objectId && opm.propertyId == propertyId,
    );
  };

  function cellRenderer(params) {
    if (
      params.dataSource != null &&
      params.dataSource.objectProperty.origin != "None"
    ) {
      return (
        <div className="d-grid gap-2 mt-1 project-config-actions">
          <button
            disabled={true}
            className="btn btn-sm btn-block btn-outline-success project-config-action-btn"
          >
            {params.dataSource.objectProperty.origin}
            {params.dataSource.objectProperty.type &&
              " - " + params.dataSource.objectProperty.type}
          </button>
        </div>
      );
    }
  }

  function cellRendererDynamicProperties(params) {
    if (params.dataSource != null && params.dataSource != "None") {
      return (
        <div className="d-grid gap-2 mt-1">
          {params.dataSource.split(",").join(", ")}
        </div>
      );
    }
  }

  const onRowValueChanged = (event) => {};

  const gridRef = useRef(null);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      width: 300,
      filter: "agSetColumnFilter",
    }),
    [],
  );

  return (
    <>
      <Modal
        show={showAddObjectPropModal}
        onHide={(e) => {
          setShowAddPropModal(false);
        }}
      >
        <Modal.Header>
          <Modal.Title>Add New Property</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={(e) => {
                setShowAddPropModal(false);
              }}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center p-1">
            <input
              type="text"
              placeholder="Property Name"
              className="form-control"
              onChange={(e) => {
                setNewProp({
                  ...newProp,
                  property: e.target.value,
                  objectGroupingId: selectedGroupingId,
                });
              }}
            />
          </div>
          <div className="d-flex justify-content-end p-1 mt-1 project-config-actions">
            <button
              className="btn btn-outline-success btn-sm project-config-action-btn"
              onClick={async (e) => {
                addObjectProp(newProp);
                setShowAddPropModal(false);
              }}
            >
              Add
            </button>
            <button
              className="btn btn-outline-success btn-sm project-config-action-btn"
              onClick={(e) => {
                setShowAddPropModal(false);
              }}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showAddObjectModal}
        onHide={(e) => {
          setShowAddObjectModal(false);
        }}
      >
        <Modal.Header>
          <Modal.Title>Add New Object</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={(e) => {
                setShowAddObjectModal(false);
              }}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center p-1">
            <input
              type="text"
              placeholder="Object Name"
              className="form-control"
              onChange={(e) => {
                //update new asset MUID
                setNewObject({
                  ...newObject,
                  category: e.target.value,
                  objectGroupingId: selectedGroupingId,
                });
              }}
            />
          </div>
          <div className="d-flex justify-content-end p-1 mt-1 project-config-actions">
            <button
              className="btn btn-outline-success btn-sm project-config-action-btn"
              onClick={async (e) => {
                //add row to grid
                await addObject(newObject);
                let tempGridData = await getOPMGridData(selectedGroupingId);
                await addCustomComponents(tempGridData);
                setGridData(tempGridData);
                setShowAddObjectModal(false);
                //refresh grid
              }}
            >
              Add
            </button>
            <button
              className="btn btn-outline-success btn-sm project-config-action-btn"
              onClick={(e) => {
                setShowAddObjectModal(false);
              }}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <div>
        <div className="bs-docs-section" style={{ margin: 0 }}>
          <div className="col-lg-12">
            <div className="page-header">
              <h1
                id="tables"
                style={{
                  paddingTop: "5px",
                  paddingBottom: "5px",
                  margin: 0,
                }}
              >
                Object Property Matrix
              </h1>
            </div>
            <div className="d-flex justify-content-between project-config-actions">
              <div className="d-flex flex-wrap gap-1">
                {objectGroupings?.map((grouping) => {
                  return (
                    <button
                      key={grouping.id}
                      className={
                        "btn btn-sm btn-outline-success project-config-action-btn"
                      }
                      onClick={() => {
                        setSelectedGroupingId(grouping.id);
                      }}
                    >
                      {grouping.name}
                    </button>
                  );
                })}
              </div>
              <div className="d-flex me-1 project-config-actions">
                <div className="mt-1">
                  <Form.Check // prettier-ignore
                    type="switch"
                    id="custom-switch"
                    label="Edit Properties"
                    checked={propertiesFlag}
                    onChange={(e) => setPropertiesFlag(!propertiesFlag)}
                  />
                </div>
                <button
                  className="btn btn-outline-success btn-sm ms-1 project-config-action-btn"
                  onClick={() => {
                    setShowAddObjectModal(true);
                  }}
                >
                  Add New Object
                </button>
                <button
                  className="btn btn-outline-success btn-sm ms-1 project-config-action-btn"
                  onClick={() => {
                    setShowAddPropModal(true);
                  }}
                >
                  Add New Property
                </button>
              </div>
            </div>
            <div
              className="mt-2"
              style={{
                height: "80vh",
              }}
            >
              {gridData && (
                <AgGridReact
                  theme={agGridTheme}
                  ref={gridRef}
                  rowData={gridData.data}
                  columnDefs={
                    propertiesFlag === false
                      ? gridData.columns
                      : gridData.dynamicPropColumns
                  }
                  defaultColDef={defaultColDef}
                  groupAllowUnbalanced={true}
                  stopEditingWhenCellsLoseFocus={true}
                  onRowValueChanged={onRowValueChanged}
                  // reactiveCustomComponents={false}
                  gridOptions={{
                    ...agGridOptionsNone,
                    autoGroupColumnDef: { filter: "agGroupColumnFilter" },
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ObjectLibrary;
